var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "wa-message",
    {
      attrs: {
        id: "trademark-heads-up",
        "icon-name": "faCircleInfo",
        "icon-style": "duotone",
        "custom-style": {
          "--fa-secondary-opacity": "1.0",
          "--fa-secondary-color": "var(--fa-dk-blue)",
          "--fa-primary-color": "var(--white)",
          "--message-margin": "0 0 var(--spacing-2xl) 0",
          "--message-border-color": "var(--fa-lt-gravy)",
        },
      },
    },
    [
      _c(
        "h3",
        { staticClass: "h5", attrs: { slot: "title" }, slot: "title" },
        [
          _vm._v("\n    Heads up!\n    "),
          !_vm.isShowingBrandNoticeDetails
            ? _c(
                "button",
                {
                  staticClass: "link underline padding-0 margin-0 b",
                  staticStyle: { "--link-color": "initial" },
                  on: {
                    click: function ($event) {
                      _vm.isShowingBrandNoticeDetails = true
                    },
                  },
                },
                [_vm._v("\n      " + _vm._s(_vm.noticeTitle) + "\n    ")]
              )
            : [_vm._v(_vm._s(_vm.noticeTitle))],
        ],
        2
      ),
      _vm._v(" "),
      _vm.isShowingBrandNoticeDetails
        ? _c("div", { attrs: { slot: "content" }, slot: "content" }, [
            _c("p", [
              _vm._v(
                "\n      If you want to use it, you have to ensure that you have the legal right to do so and that you do not infringe any trademark rights. The use of these\n      trademarks does not indicate endorsement of the trademark holder by Font Awesome, nor vice versa.\n    "
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "See the trademark owner for rules about appropriate use of their trademarks."
              ),
            ]),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }